import { asText, Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import DynamicMarquee from '@/components/DynamicMarquee';

/**
 * Props for `HighlightedCard`.
 */
export type HighlightedCardProps =
  SliceComponentProps<Content.HighlightedCardSlice>;

/**
 * Component for "HighlightedCard" Slices.
 */
const HighlightedCard = ({ slice }: HighlightedCardProps): JSX.Element => {
  const { title, content, companies, footer_text: footerText } = slice.primary;
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="px-8 py-20 flex flex-col text-white bg-primary-darker-green-emerald-shadow rounded-[20px] shadow-green-shadow gap-y-8"
    >
      <h2 className="text-h3">{asText(title)}</h2>
      <PrismicRichText
        field={content}
        components={{
          paragraph: ({ children }) => (
            <p className="text-medium-normal">{children}</p>
          ),
          list: ({ children }) => (
            <ul className="list-with-icon flex flex-col gap-y-4 text-regular-normal">
              {children}
            </ul>
          ),
        }}
      />
      <DynamicMarquee autoFill speed={40} className="my-6">
        <div className="flex gap-x-11 items-center mx-5">
          {companies.map((company, index) => (
            <div key={`company-logo-${index}`}>
              <PrismicNextImage
                field={company.company_logo}
                className="h-10 object-contain"
              />
            </div>
          ))}
        </div>
      </DynamicMarquee>

      <div className="text-medium-normal text-center">
        <PrismicRichText field={footerText} />
      </div>
    </section>
  );
};

export default HighlightedCard;
